export default __webpack_public_path__ + "assets/fc0f4aa9db8de472f49b7be153a275b7.svg";